module.exports = __webpack_public_path__ + "static/media/watercolor_blot.92bc7d83.png";